///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { GtthNotificationModel } from './notifications.model';

@Injectable({ providedIn: 'root' })
export class GtthNotificationsService {
    private notificationsArray: GtthNotificationModel[] = [];
    private readonly notifications$: Subject<GtthNotificationModel[]> = new Subject<GtthNotificationModel[]>();
    private _showNotifications = false;

    get showNotifications(): boolean {
        return this._showNotifications;
    }

    set showNotifications(isShow: boolean) {
        this._showNotifications = isShow;
    }

    addNotification(notification: GtthNotificationModel): void {
        this.notificationsArray.push(notification);
        this.notifications$.next(this.notificationsArray);
    }

    clearNotifications(): void {
        this.notificationsArray = [];
        this.notifications$.next(this.notificationsArray);
    }

    getNotifications(): Observable<GtthNotificationModel[]> {
        return this.notifications$.asObservable();
    }
}
